import React from 'react';
import { BadgeCheckIcon, StarIcon } from 'lucide-react';
import { SectionCTA } from '../SectionCTA';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <section className="w-full bg-brand-light px-5 py-16 sm:py-20" data-id="element-302" data-mp="3mgahwr509ut0">
      <div className="mx-auto max-w-5xl" data-id="element-303" data-mp="3mezeisfh2p2f">
        <h2 className="text-center font-display text-[28px] font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-304" data-mp="3r8kc4jd5lh13">
          What Pediatric Therapists Are Saying
        </h2>
        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-305" data-mp="42jblkd62eh8">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6 shadow-sm" data-id="element-306" data-mp="91e6hkoerthp">
              <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-307" data-mp="e1ikn41ugc4r">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-accent text-accent" aria-hidden="true" data-id="element-308" data-mp="2autu08p78s8g" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 text-[16px] leading-relaxed text-navy" data-id="element-309" data-mp="1skj2k7q2oriu">“{t.quote}”</blockquote>
              <figcaption className="mt-auto flex items-center gap-4 pt-6" data-id="element-310" data-mp="1ntszj154d0rb">
                <img src={t.image} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-brand-light" data-id="element-311" data-mp="1nrq05qi2tv9x" />
                <div data-id="element-312" data-mp="1etebhu0rt7k4">
                  <p className="flex items-center gap-1.5 font-display font-extrabold text-navy" data-id="element-313" data-mp="1eu5vs8ox3iv3">
                    {t.name}
                    <BadgeCheckIcon className="h-4 w-4 text-brand" aria-label="Verified buyer" data-id="element-314" data-mp="2bily75d4lmpm" />
                  </p>
                  <p className="text-sm text-navy/65" data-id="element-315" data-mp="26i7rprr6aktp">{t.role}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>
        <SectionCTA label="Join These Therapists Today" data-id="element-316" data-mp="1xikod0evv4y0" />
      </div>
    </section>;
}